<div class="flexbox-row justify-content-between flex-wrap">
        <div class="vertical-items">
            <button mat-button aria-label="Back" class="button-text" (click)="goBackToExportData();$event.stopPropagation()">
                <span class="flexbox-row gap-8">
                    <i class="fa-regular fa-chevron-left"></i>
                    <span class="button-label">Back</span>
                </span>
            </button>

        </div>
        <div class="d-flex align-items-center gap-3 flex-sm-nowrap flex-wrap">
            <ng-container>
                <p class="fw-medium">Total '{{ client() }} Clients' and '{{ eng() }} Engagements'</p>
            </ng-container>
            <button mat-button mat-flat-button color="primary" class="button-default" (click)="onBtnExport()">
                <i class="fa-regular fa-file-export"></i>
                Export All Data
            </button>
        </div>

</div>

<div class="card table-responsive flex-1">
    <table mat-table [dataSource]="dataSource" matSort class="table-countable">

        <!-- All Columns -->
        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{columnDefs[column]}} </th>
            <td mat-cell *matCellDef="let row">
                <span *ngIf="column !== 'engagementType'; else engType">{{row[column]}} </span>
                <ng-template #engType>
                    @if (row[column].includes('Compilation')) {
                        <p class="badge badge-pills badge-medium  badge-purple">Compilation</p>
                    } @else if (row[column].includes('Review')) {
                        <p class="badge badge-pills badge-medium  badge-tertiary-blue">Review</p>
                    } @else {
                        <p class="badge badge-pills badge-medium  badge-pink">{{ row[column] }}</p>
                    }

                </ng-template>
            </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                No data matching the filter.
            </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
